import React, { useEffect, useState } from 'react';
import Sidebar from './Layouts/Sidebar';
import styles from './../Assets/CSS/Style.module.css';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL, BASE_FILE_URL } from './../Environment';
import { toast } from 'react-toastify';

const colorPalette = [
    '#FF6B6B', '#4ECDC4', '#45B7D1', '#F7DC6F',
    '#BB8FCE', '#85C1E2', '#F8B500', '#52BE80',
    '#EC7063', '#AF7AC5', '#5DADE2', '#48C9B0'
];

function AllVideoCategories() {
    const navigate = useNavigate();
    const [categories, setCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        document.title = 'Infomart | All Video Categories';
        setIsLoading(true);
        axios.get(`${BASE_URL}/video-category`, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((res) => {
            setCategories(res.data.data);
            setIsLoading(false);
        }).catch((error) => {
            toast.error('Error fetching categories', { autoClose: 3000 });
            setIsLoading(false);
        });
    }, []);

    const handleMenu = (slug) => {
        navigate(`/video/${slug}`);
    };

    return (
        <div className="app">
            <div className="outlet">
                <div className="homeLayout">
                    <Sidebar />
                    <div className={styles.home_container}>
                        <h4 style={{ fontWeight: '700', marginBottom: '20px', color: '#333', width: '100%' }}>
                            Choose a Category
                        </h4>
                        {isLoading ? (
                            <h5 className="text-center mt-5">Loading...</h5>
                        ) : (
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
                                gap: '16px',
                                width: '100%',
                            }}>
                                {categories.map((category, index) => {
                                    const bgColor = colorPalette[index % colorPalette.length];
                                    return (
                                        <div
                                            key={category.id || index}
                                            onClick={() => handleMenu(category.slug)}
                                            style={{
                                                backgroundColor: bgColor + '1A',
                                                borderRadius: '14px',
                                                padding: '20px 12px',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                cursor: 'pointer',
                                                transition: 'transform 0.2s, box-shadow 0.2s',
                                                border: `1px solid ${bgColor}30`,
                                                minHeight: '140px',
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = 'translateY(-4px)';
                                                e.currentTarget.style.boxShadow = `0 8px 20px ${bgColor}40`;
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = 'none';
                                            }}
                                        >
                                            <div style={{
                                                width: '60px',
                                                height: '60px',
                                                borderRadius: '16px',
                                                backgroundColor: bgColor,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                marginBottom: '12px',
                                                overflow: 'hidden',
                                            }}>
                                                {category.icon ? (
                                                    <img
                                                        src={BASE_FILE_URL + category.icon}
                                                        alt={category.name}
                                                        style={{
                                                            width: '36px',
                                                            height: '36px',
                                                            objectFit: 'contain',
                                                            filter: 'brightness(0) invert(1)',
                                                        }}
                                                    />
                                                ) : (
                                                    <span style={{ fontSize: '28px' }}>🎬</span>
                                                )}
                                            </div>
                                            <span style={{
                                                fontSize: '13px',
                                                fontWeight: '600',
                                                color: '#333',
                                                textAlign: 'center',
                                                lineHeight: '1.3',
                                                wordBreak: 'break-word',
                                            }}>
                                                {category.name}
                                            </span>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AllVideoCategories; 